import { render, staticRenderFns } from "./_ObjectiveQuestion.vue?vue&type=template&id=eb0ff54c"
import script from "./_ObjectiveQuestion.vue?vue&type=script&lang=js"
export * from "./_ObjectiveQuestion.vue?vue&type=script&lang=js"
import style0 from "./_ObjectiveQuestion.vue?vue&type=style&index=0&id=eb0ff54c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports